<template>
  <div class="header-container">
    <div class="header__gov">
      <div class="headGrey" @click="openEnglish">
        <img src="../assets//images/earth.png" alt="" />
        <span class="header__locale">Global</span>
        <span class="header__language">English</span>
      </div>
      <div class="logoBorder">
        <div>
          <div class="logo">
            <a href="https://www.smith-nephew.com.cn">
              <img src="../assets/images/Logo.svg" alt="" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  created() {},
  methods: {
    openEnglish() {
      this.$emit("childEvent", true);
    },
  },
};
</script>
<style lang="scss" scoped>
.header-container {
  // height: 6vh;
  .header__gov {
    .headGrey {
      background-color: #f6f8f9;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      line-height: 1;
      padding: 12px 10px;
      @media (min-width: 1000px) and (max-width: 1920px) {
        padding: 10px 10px;
      }
      display: flex;
      align-items: center;
      line-height: 1;
      height: 20%;
      position: relative;
      cursor: pointer;
      img {
        width: 17px;
        @media (min-width: 1000px) and (max-width: 1920px) {
          width: 12px;
        }
      }
      .header__locale {
        margin: 0 16px 0 10px;
        @media (min-width: 1000px) and (max-width: 1920px) {
          font-size: 10px;
          // margin: 0 3px 0 10px;
        }
      }
      .header__language {
        @media (min-width: 1000px) and (max-width: 1920px) {
          font-size: 10px;
        }
      }
      .header__language:before {
        content: "";
        width: 1px;
        height: 30%;
        border-left: 1px solid;
        position: absolute;
        top: 14px;
        margin-left: -8px;
        @media (min-width: 1000px) and (max-width: 1920px) {
          top: 12px;
          width: 0.5px;
          border-left: 0.39px solid;
          height: 25%;
        }
        @media (max-width: 1000px) {
          top: 14px;
        }
      }
    }
    .logoBorder {
      border: 1px solid #eceeee;
      // display: flex;
      // justify-content: center;
      // align-items: center;
      > div {
        padding: 28px 0;
      }
      .logo {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        margin: 0 4rem;
        width: calc(100% - 8rem);
        img {
          line-height: 14px;
          margin: 0;
          padding: 0;
        }
      }
    }
  }
}
</style>